import React, { useState, useEffect, useRef } from "react";
import { Modal, Box, Typography, Alert } from "@mui/material";
import Select from "../../ui/PortalSelect";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import "antd/dist/antd.css";
import './BusinessHours.css'
import { DatePicker } from 'antd';
import Swal from 'sweetalert2';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import axios from 'axios';
import {
  fetchJson,
  getUserAccountType,
  loadAccessibleCompanies,
  readSessionUser,
  requireArray,
} from '../accountAccess';
import { readJsonResponse } from '../saveResponse';
import {
  expectExactPayload,
  requestErrorMessage,
} from '../mutationContract';
import { buildCompanyOptions, findCompanyById } from '../companyLocation/companySelection';
import { getEntitySelectProps } from '../../ui/selectPresentation';
import {
  businessHoursDatePayload,
  parseBusinessHoursDate,
} from './businessHoursDate';


export default function UpdateForm({ accessType }) {
  const [companyDetail, setcompanyDetail] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [locationDetail, setLocationDetail] = useState([]);
  const [updatedFlag, setUpdatedFlag] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [specialDaysModal, setSpecialDaysModal] = useState(false)
  const [specialDaysSelected, setSpecialDaysSelected] = useState();
  const [locationCheckedState, setLocationCheckedState] = useState([]);
  const [type, setType] = useState('');
  const [hour, setHour] = useState(
    [
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"]
    ]
  );
  const [specialHour, setSpecialHour] = useState(["00:00", "00:00", "00:00", "00:00"]);
  const [businessHours, setBusinessHours] = useState(null);
  const [update, setUpdate] = useState(false);
  const [editValue, setEditValue] = useState([{}]);
  const [specialDaysUpdateFlag, setSpecialDaysUpdateFlag] = useState(false);
  const [loggedInUserDetail, setLoggedInUserDetail] = useState(null);
  const [specialDayName, setSpecialDayName] = useState("");
  const [accountsLoading, setAccountsLoading] = useState(true);
  const [accountsError, setAccountsError] = useState("");
  const [locationsLoading, setLocationsLoading] = useState(false);
  const [locationsError, setLocationsError] = useState("");
  const [businessHoursLoading, setBusinessHoursLoading] = useState(false);
  const [businessHoursError, setBusinessHoursError] = useState("");

  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});

  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    let active = true;

    const loadCompanies = async () => {
      setAccountsLoading(true);
      setAccountsError("");

      const { user, error } = readSessionUser();
      if (error) {
        if (active) {
          setLoggedInUserDetail(null);
          setcompanyDetail([]);
          setAccountsError(error);
          setAccountsLoading(false);
        }
        return;
      }

      setLoggedInUserDetail(user);

      try {
        const accounts = await loadAccessibleCompanies(
          baseURL,
          user,
          'BusinessHours_Account Access',
          { suppressGlobalError: true }
        );
        const validAccounts = accounts.filter((account) => (
          account
          && typeof account === 'object'
          && account._id !== undefined
          && account._id !== null
          && String(account._id).trim() !== ''
          && typeof account.company_name === 'string'
          && account.company_name.trim() !== ''
          && typeof account.account_type === 'string'
          && account.account_type.trim() !== ''
        ));

        if (validAccounts.length !== accounts.length) {
          throw new Error('Account list returned incomplete account details.');
        }

        if (active) {
          setcompanyDetail(validAccounts);
          setSelectedCompanyId((currentId) => {
            if (validAccounts.some((account) => String(account._id) === currentId)) {
              return currentId;
            }
            return validAccounts.length === 1 ? String(validAccounts[0]._id) : '';
          });
        }
      } catch (error) {
        if (active) {
          setcompanyDetail([]);
          setSelectedCompanyId('');
          setAccountsError(error.message || 'Accounts could not be loaded.');
        }
      } finally {
        if (active) {
          setAccountsLoading(false);
        }
      }
    };

    loadCompanies();

    return () => {
      active = false;
    };
  }, []);

  // Load the selected account's locations, user allocation and existing hours.
  useEffect(() => {
    let active = true;

    const resetSelectedAccount = () => {
      setcompany_id('');
      setLocationDetail([]);
      setLocationCheckedState([]);
      setHashLocationNameVsID({});
      setBusinessHours([]);
      setLocationsError('');
      setBusinessHoursError('');
      setLocationsLoading(false);
      setBusinessHoursLoading(false);
    };

    if (!selectedCompanyId || !loggedInUserDetail) {
      resetSelectedAccount();
      return () => {
        active = false;
      };
    }

    const selectedAccount = findCompanyById(companyDetail, selectedCompanyId);

    if (!selectedAccount) {
      resetSelectedAccount();
      setLocationsError('The selected account is no longer available. Please choose another account.');
      return () => {
        active = false;
      };
    }

    const resolvedCompanyId = String(selectedAccount._id);
    const selectedCompanyType = selectedAccount.account_type;

    setcompany_id(resolvedCompanyId);
    setLocationDetail([]);
    setLocationCheckedState([]);
    setHashLocationNameVsID({});
    setBusinessHours([]);
    setLocationsError('');
    setBusinessHoursError('');
    setLocationsLoading(true);
    setBusinessHoursLoading(false);

    setFromDate("");
    setToDate("");
    setType("");
    setUpdate(false);
    setEditValue([]);
    setSpecialDaysSelected("");
    setSpecialDaysUpdateFlag(false);
    setHour([
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"]
    ]);

    const loadSelectedAccount = async () => {
      let allLocations;

      try {
        const locationData = await fetchJson(
          baseURL + '/get_company_location/' + encodeURIComponent(resolvedCompanyId)
          + '?companyNumber=' + encodeURIComponent(resolvedCompanyId),
          {
            method: 'GET',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json' },
          },
          'Locations'
        );
        allLocations = requireArray(locationData?.res, 'Locations').filter((location) => (
          location
          && typeof location === 'object'
          && location.location_id !== undefined
          && location.location_id !== null
          && typeof location.location_name === 'string'
          && location.location_name.trim() !== ''
        ));

        const locationNameById = allLocations.reduce((result, location) => {
          result[location.location_id] = location.location_name;
          return result;
        }, {});

        let allowedLocations = allLocations;
        let locationAllocation = null;
        const canUseAllLocations = loggedInUserDetail.role_capabilities?.all_modules_access === true
          || (
            selectedCompanyType === 'Affiliate'
            && getUserAccountType(loggedInUserDetail) === 'Corporate'
          );

        if (!canUseAllLocations) {
          if (!loggedInUserDetail.userEmail) {
            throw new Error('Your user email is missing from the login session. Please sign in again.');
          }

          const allocationData = await fetchJson(
            baseURL + '/get_individual_user_details',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                user_email: loggedInUserDetail.userEmail,
                companyNumber: resolvedCompanyId,
              }),
            },
            'Location allocation'
          );
          const users = requireArray(allocationData, 'Location allocation');
          locationAllocation = users[0]?.location_allocated;

          if (!locationAllocation || typeof locationAllocation !== 'object' || Array.isArray(locationAllocation)) {
            throw new Error('No valid location allocation was found for your user and this account.');
          }

          allowedLocations = allLocations.filter(
            (location) => Boolean(locationAllocation[location.location_id])
          );
        }

        if (!active) {
          return;
        }

        setHashLocationNameVsID(locationNameById);
        setLocationDetail(allowedLocations);
        setLocationCheckedState(allowedLocations.map(() => true));
        setLocationsLoading(false);

        if (allowedLocations.length === 0) {
          setBusinessHours([]);
          return;
        }

        setBusinessHoursLoading(true);

        try {
          let hoursData = requireArray(
            await fetchJson(
              baseURL + '/get_business_hours/' + encodeURIComponent(resolvedCompanyId)
              + '?companyNumber=' + encodeURIComponent(resolvedCompanyId),
              {
                method: 'GET',
                mode: 'cors',
                headers: { 'Content-Type': 'application/json' },
              },
              'Business hours'
            ),
            'Business hours'
          );

          if (locationAllocation) {
            hoursData = hoursData.filter(
              (hours) => hours && Boolean(locationAllocation[hours.location_id])
            );
          }

          if (active) {
            setBusinessHours(hoursData);
          }
        } catch (error) {
          if (active) {
            setBusinessHours([]);
            setBusinessHoursError(error.message || 'Business hours could not be loaded.');
          }
        } finally {
          if (active) {
            setBusinessHoursLoading(false);
          }
        }
      } catch (error) {
        if (active) {
          setLocationDetail([]);
          setLocationCheckedState([]);
          setBusinessHours([]);
          setLocationsError(error.message || 'Locations could not be loaded.');
          setLocationsLoading(false);
          setBusinessHoursLoading(false);
        }
      }
    };

    loadSelectedAccount();

    return () => {
      active = false;
    };
  }, [selectedCompanyId, companyDetail, loggedInUserDetail, updatedFlag]);


  // cancel update
  const cancelUpdate = (e) => {

    e.preventDefault();

    setType("");
    setUpdate(false);
    setSpecialDaysUpdateFlag(false);
    setEditValue([]);
    setSpecialDaysSelected("");
    setFromDate("");
    setToDate("");

    let location_arr = [];
    for (let i = 0; i < locationDetail.length; i++) {
      location_arr.push(true)
    }

    setLocationCheckedState(location_arr);

    setHour([
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"],
      ["00:00", "00:00", "00:00", "00:00", "00:00", "00:00", "00:00"]
    ]);

  }// cancel update ends


  //OnSubmit code
  const submitHandler = (e) => {
    e.preventDefault();

    if (type === '') {
      Swal.fire('Please select type');
      return;
    }
    const fromDatePayload = businessHoursDatePayload(fromDate);
    const toDatePayload = businessHoursDatePayload(toDate);
    if (!fromDatePayload || !toDatePayload) {
      Swal.fire('Please select date');
      return;
    }
    if (fromDatePayload > toDatePayload) {
      Swal.fire('From Date cannot be after To Date');
      return;
    }
    const d = new Date();
    const id = d.getTime().toString();

    var arr_json_mapping = [];
    for (let i = 0; i < locationDetail.length; i++) {
      if (locationCheckedState[i] === false) {
        arr_json_mapping.push({
          "_id": locationDetail[i].location_id + "-" + type + "-" + id, // _id = location_id + type + now time in miliseconds
          "company_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "location_id": locationDetail[i].location_id,
          "location_name": locationDetail[i].location_name,
          "type": type,
          "from_date": fromDatePayload,
          "to_date": toDatePayload,
          "sunday": { "open1": hour[0][0], "close1": hour[1][0], "open2": hour[2][0], "close2": hour[3][0] },
          "monday": { "open1": hour[0][1], "close1": hour[1][1], "open2": hour[2][1], "close2": hour[3][1] },
          "tuesday": { "open1": hour[0][2], "close1": hour[1][2], "open2": hour[2][2], "close2": hour[3][2] },
          "wednesday": { "open1": hour[0][3], "close1": hour[1][3], "open2": hour[2][3], "close2": hour[3][3] },
          "thursday": { "open1": hour[0][4], "close1": hour[1][4], "open2": hour[2][4], "close2": hour[3][4] },
          "friday": { "open1": hour[0][5], "close1": hour[1][5], "open2": hour[2][5], "close2": hour[3][5] },
          "saturday": { "open1": hour[0][6], "close1": hour[1][6], "open2": hour[2][6], "close2": hour[3][6] },
          // "special_day": specialDaysSelected._d,
          // "special_hour": { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] },
          "created_date": new Date(),
          "updated_date": new Date(),
          "created_by": loggedInUserDetail.userEmail,
          'updated_by': loggedInUserDetail.userEmail
        });
      }
    }

    if (arr_json_mapping.length < 1) {
      Swal.fire('Please select location(s)');
      return;
    }

    //API call for inserting data in DB
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arr_json_mapping),
    };

    fetch(baseURL + "/save_business_hours", requestOptions)
      .then((res) => readJsonResponse(res, 'Business Hours save'))
      .then((data) => {

        if (data === "already present") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Already Present',
            showConfirmButton: false,
            timer: 3000
          })

        }
        else {
          expectExactPayload(data, 'success', 'Business Hours save');
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Saved Successfully',
            showConfirmButton: false,
            timer: 3000
          })
          setUpdatedFlag(!updatedFlag);

          setFromDate("");
          setToDate("");
          setType("");
          setUpdate(false);
          setEditValue([{}]);
          setSpecialDaysSelected("");

          const updatedCheckedState = locationCheckedState.map(() => true);
          setLocationCheckedState(updatedCheckedState);
        }
      })
      .catch((error) => {
        console.error('Unable to save Business Hours:', error)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Save failed',
          text: requestErrorMessage(error, 'Unable to save Business Hours. Please try again.')
        })
      });



  }; //submitHandler func ends here

  //on special days update
  const updateSpecialDaysHandler = (e) => {

    e.preventDefault();

    //API call for inserting data in DB
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "account_id": company_id.toString(),
        "companyNumber": company_id.toString(),
        "location_id": editValue.location_id.toString(),
        "sunday": { "open1": hour[0][0], "close1": hour[1][0], "open2": hour[2][0], "close2": hour[3][0] },
        "monday": { "open1": hour[0][1], "close1": hour[1][1], "open2": hour[2][1], "close2": hour[3][1] },
        "tuesday": { "open1": hour[0][2], "close1": hour[1][2], "open2": hour[2][2], "close2": hour[3][2] },
        "wednesday": { "open1": hour[0][3], "close1": hour[1][3], "open2": hour[2][3], "close2": hour[3][3] },
        "thursday": { "open1": hour[0][4], "close1": hour[1][4], "open2": hour[2][4], "close2": hour[3][4] },
        "friday": { "open1": hour[0][5], "close1": hour[1][5], "open2": hour[2][5], "close2": hour[3][5] },
        "saturday": { "open1": hour[0][6], "close1": hour[1][6], "open2": hour[2][6], "close2": hour[3][6] },
        "updated_date": new Date(),
        'updated_by': loggedInUserDetail.userEmail
      }),
    };


    fetch(baseURL + "/update_special_days_business_hours/" + editValue._id.toString(), requestOptions)
      .then((res) => readJsonResponse(res, 'Special Day Business Hours update'))
      .then((data) => {
        expectExactPayload(data, 'Updated Successfully !!', 'Special Day Business Hours update');

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Updated Successfully',
          showConfirmButton: false,
          timer: 3000
        })

        setUpdatedFlag(!updatedFlag);

        setFromDate("");
        setToDate("");
        setType("");
        setUpdate(false);
        setEditValue([{}]);
        setSpecialDaysSelected("");

        const updatedCheckedState = locationCheckedState.map(() => true);
        setLocationCheckedState(updatedCheckedState);
        setSpecialDaysUpdateFlag(false);
      })
      .catch((error) => {
        console.error('Unable to update Special Day Business Hours:', error)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Update failed',
          text: requestErrorMessage(error, 'Unable to update Special Day Business Hours. Please try again.')
        })
      });

  }//special day update ends here


  //On update code
  const updateHandler = (e) => {
    e.preventDefault();

    if (!specialDaysUpdateFlag && type === '') {
      Swal.fire('Please select type');
      return;
    }
    if (!specialDaysUpdateFlag && (fromDate === "" || fromDate === null || fromDate === undefined || fromDate === 'undefined'
      || toDate === "" || toDate === null || toDate === undefined || toDate === 'undefined')) {
      Swal.fire('Please select date');
      return;
    }

    const fromDatePayload = businessHoursDatePayload(fromDate);
    const toDatePayload = businessHoursDatePayload(toDate);
    if (!specialDaysUpdateFlag && (!fromDatePayload || !toDatePayload)) {
      Swal.fire('Please select a valid date');
      return;
    }
    if (!specialDaysUpdateFlag && fromDatePayload > toDatePayload) {
      Swal.fire('From Date cannot be after To Date');
      return;
    }

    var arr_json_mapping = [];
    for (let i = 0; i < locationDetail.length; i++) {
      if (locationCheckedState[i] === false) {
        arr_json_mapping.push({
          "_id": editValue._id,
          "company_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "location_id": locationDetail[i].location_id,
          "location_name": locationDetail[i].location_name,
          "type": type,
          "from_date": fromDatePayload,
          "to_date": toDatePayload,
          "sunday": { "open1": hour[0][0], "close1": hour[1][0], "open2": hour[2][0], "close2": hour[3][0] },
          "monday": { "open1": hour[0][1], "close1": hour[1][1], "open2": hour[2][1], "close2": hour[3][1] },
          "tuesday": { "open1": hour[0][2], "close1": hour[1][2], "open2": hour[2][2], "close2": hour[3][2] },
          "wednesday": { "open1": hour[0][3], "close1": hour[1][3], "open2": hour[2][3], "close2": hour[3][3] },
          "thursday": { "open1": hour[0][4], "close1": hour[1][4], "open2": hour[2][4], "close2": hour[3][4] },
          "friday": { "open1": hour[0][5], "close1": hour[1][5], "open2": hour[2][5], "close2": hour[3][5] },
          "saturday": { "open1": hour[0][6], "close1": hour[1][6], "open2": hour[2][6], "close2": hour[3][6] },
          "updated_date": new Date(),
          'updated_by': loggedInUserDetail.userEmail,
        });
      }
    }

    if (arr_json_mapping.length < 1) {
      Swal.fire('Please select location(s)');
      return;
    }

    //API call for inserting data in DB
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arr_json_mapping),
    };

    fetch(baseURL + "/update_business_hours", requestOptions)
      .then((res) => readJsonResponse(res, 'Business Hours update'))
      .then((data) => {
        expectExactPayload(data, 'Updated Successfully !!', 'Business Hours update');

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Updated Successfully',
          showConfirmButton: false,
          timer: 3000
        })
        setUpdatedFlag(!updatedFlag);

        setFromDate("");
        setToDate("");
        setType("");
        setUpdate(false);
        setEditValue([]);
        setSpecialDaysSelected("");

        const updatedCheckedState = locationCheckedState.map(() => true);
        setLocationCheckedState(updatedCheckedState);
        setSpecialDaysUpdateFlag(false);
      })
      .catch((error) => {
        console.error('Unable to update Business Hours:', error)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Update failed',
          text: requestErrorMessage(error, 'Unable to update Business Hours. Please try again.')
        })
      });

  }; //updateHandler func ends here



  const handleLocationCheck = (position) => {
    const updatedCheckedState = locationCheckedState.map((item, index) =>
      index === position ? !item : item
    );
    setLocationCheckedState(updatedCheckedState);
  }

  //Special Day Hours
  const handleSpecialHour = (val, position) => {
    const updatedSpecialHour = specialHour.map((item, index) =>
      index === position ? val : item
    );

    setSpecialHour(updatedSpecialHour);
  }

  // Hours 
  const handleHour = (val, position_y, position_x) => {

    const updatedHour = [];

    for (let i = 0; i < hour.length; i++) {
      if (i === position_y) {

        const updatedHourTemp = hour[i]
        updatedHourTemp[position_x] = val;
        updatedHour.push(updatedHourTemp);

      }
      else
        updatedHour.push(hour[i])

    }

    setHour(updatedHour);
  }

  //Option for company name
  const companyNameOptions = buildCompanyOptions(companyDetail);
  const selectedCompany = findCompanyById(companyDetail, selectedCompanyId);
  const selectedCompanyOption = companyNameOptions.find(
    (option) => option.value === selectedCompanyId
  ) || null;

  const handleInputChangeCompanyName = characterEntered => {
    setSelectedCompanyId(characterEntered?.value || '');
  };


  //Working Hours
  const hours = [
    { "name": "00:00" }, { "name": "00:15" }, { "name": "00:30" }, { "name": "00:45" }, { "name": "01:00" }, { "name": "01:15" }, { "name": "01:30" }, { "name": "01:45" }, { "name": "02:00" }, { "name": "02:15" }, { "name": "02:30" }, { "name": "02:45" }, { "name": "03:00" }, { "name": "03:15" },
    { "name": "03:30" }, { "name": "03:45" }, { "name": "04:00" }, { "name": "04:15" }, { "name": "04:30" }, { "name": "04:45" }, { "name": "05:00" }, { "name": "05:15" }, { "name": "05:30" }, { "name": "05:45" }, { "name": "06:00" }, { "name": "06:15" }, { "name": "06:30" }, { "name": "06:45" },
    { "name": "07:00" }, { "name": "07:15" }, { "name": "07:30" }, { "name": "07:45" }, { "name": "08:00" }, { "name": "08:15" }, { "name": "08:30" }, { "name": "08:45" }, { "name": "09:00" }, { "name": "09:15" }, { "name": "09:30" }, { "name": "09:45" }, { "name": "10:00" }, { "name": "10:15" },
    { "name": "10:30" }, { "name": "10:45" }, { "name": "11:00" }, { "name": "11:15" }, { "name": "11:30" }, { "name": "11:45" }, { "name": "12:00" }, { "name": "12:15" }, { "name": "12:30" }, { "name": "12:45" }, { "name": "13:00" }, { "name": "13:15" }, { "name": "13:30" }, { "name": "13:45" },
    { "name": "14:00" }, { "name": "14:15" }, { "name": "14:30" }, { "name": "14:45" }, { "name": "15:00" }, { "name": "15:15" }, { "name": "15:30" }, { "name": "15:45" }, { "name": "16:00" }, { "name": "16:15" }, { "name": "16:30" }, { "name": "16:45" }, { "name": "17:00" }, { "name": "17:15" },
    { "name": "17:30" }, { "name": "17:45" }, { "name": "18:00" }, { "name": "18:15" }, { "name": "18:30" }, { "name": "18:45" }, { "name": "19:00" }, { "name": "19:15" }, { "name": "19:30" }, { "name": "19:45" }, { "name": "20:00" }, { "name": "20:15" }, { "name": "20:30" }, { "name": "20:45" },
    { "name": "21:00" }, { "name": "21:15" }, { "name": "21:30" }, { "name": "21:45" }, { "name": "22:00" }, { "name": "22:15" }, { "name": "22:30" }, { "name": "22:45" }, { "name": "23:00" }, { "name": "23:15" }, { "name": "23:30" }, { "name": "23:45" }, { "name": "23:59" },


  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: 'calc(100% - 24px)', sm: 480 },
    maxWidth: '100%',
    maxHeight: 'calc(100vh - 24px)',
    overflowY: 'auto',
    boxSizing: 'border-box',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: { xs: 2, sm: 4 },
  };

  let month = ''
  let dateDay = ''
  const dateFormat = (str) => {
    if (str.toString().length < 2)
      str = "0" + str.toString()
    return str
  }


  const handleDelete = (id, locationIdToDelete) => {

    Swal.fire({
      title: 'Are you sure you want to delete ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        //API call for inserting data in DB
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          }

        };


        axios.post(baseURL + "/delete_business_hours", {
          '_id': id,
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'location_id': locationIdToDelete.toString(),
          "updated_date": new Date(),
          'updated_by': loggedInUserDetail.userEmail,
        })
          .then((res) => {
            expectExactPayload(res.data, 'Deleted Successfully !!', 'Business Hours delete');
            setUpdatedFlag(!updatedFlag);
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Deleted Successfully !!',
              showConfirmButton: false,
              timer: 3000
            })
          })
          .catch((error) => {
            console.error('Unable to delete Business Hours:', error)
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Delete failed',
              text: requestErrorMessage(error, 'Unable to delete Business Hours. Please try again.')
            })
          });


      }
      else {
        Swal.fire('Changes are not saved');
      }


    })
  }

  //Handle Special days
  const handleSpecialDays = () => {

    setSpecialDaysModal(!specialDaysModal);

    let arr_json_mapping = [];
    let day_name = specialDaysSelected._d.toString().split(" ")[0];
    let arr_day = [{ "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },
    { "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },
    { "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },
    { "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },
    { "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },
    { "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },
    { "open1": "00:00", "close1": "00:00", "open2": "00:00", "close2": "00:00" },];
    if (day_name === "Sun")
      arr_day[0] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }
    else if (day_name === "Mon")
      arr_day[1] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }
    else if (day_name === "Tue")
      arr_day[2] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }
    else if (day_name === "Wed")
      arr_day[3] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }
    else if (day_name === "Thu")
      arr_day[4] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }
    else if (day_name === "Fri")
      arr_day[5] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }
    else if (day_name === "Sat")
      arr_day[6] = { "open1": specialHour[0], "close1": specialHour[1], "open2": specialHour[2], "close2": specialHour[3] }

    const d = new Date();
    const id = d.getTime().toString();

    for (let i = 0; i < locationDetail.length; i++) {
      if (locationCheckedState[i] === false) {
        arr_json_mapping.push({
          "_id": locationDetail[i].location_id + "-" + type + "-" + id,
          "company_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "location_id": locationDetail[i].location_id,
          "location_name": locationDetail[i].location_name,
          "type": "Special Day",
          "special_day_name": specialDayName,
          "from_date": businessHoursDatePayload(specialDaysSelected),
          "to_date": businessHoursDatePayload(specialDaysSelected),
          "sunday": arr_day[0],
          "monday": arr_day[1],
          "tuesday": arr_day[2],
          "wednesday": arr_day[3],
          "thursday": arr_day[4],
          "friday": arr_day[5],
          "saturday": arr_day[6],
          "created_date": new Date(),
          "updated_date": new Date(),
          "created_by": loggedInUserDetail.userEmail,
          'updated_by': loggedInUserDetail.userEmail
        });
      }
    }

    if (arr_json_mapping.length < 1) {
      Swal.fire('Please select location(s)');
      return;
    }


    //API call for inserting data in DB
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arr_json_mapping),
    };

    fetch(baseURL + "/save_business_hours", requestOptions)
      .then((res) => readJsonResponse(res, 'Special Day Business Hours save'))
      .then((data) => {

        if (data === "already present") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Already Present',
            showConfirmButton: false,
            timer: 3000
          })
        }
        else {
          expectExactPayload(data, 'success', 'Special Day Business Hours save');
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Special Day Saved Successfully !!',
            showConfirmButton: false,
            timer: 3000
          })
          setUpdatedFlag(!updatedFlag);
          setSpecialDaysSelected(null);
        }
      })
      .catch((error) => {
        console.error('Unable to save Special Day Business Hours:', error)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Save failed',
          text: requestErrorMessage(error, 'Unable to save Special Day Business Hours. Please try again.')
        })
      });

  }


  const handleUpdate = (val) => {

    setUpdate(true);
    setEditValue(val);

    setFromDate(parseBusinessHoursDate(val.from_date));
    setToDate(parseBusinessHoursDate(val.to_date));
    setType(val.type);

    let location_arr = [];
    for (let i = 0; i < locationDetail.length; i++) {

      if (locationDetail[i].location_id === val.location_id) {
        location_arr.push(false);
      }
      else {
        location_arr.push(true);
      }
    }

    setLocationCheckedState(location_arr);

    //setting work hours

    let hour_sunday = val.sunday;
    let hour_monday = val.monday;
    let hour_tuesday = val.tuesday;
    let hour_wednesday = val.wednesday;
    let hour_thursday = val.thursday;
    let hour_friday = val.friday;
    let hour_saturday = val.saturday

    const hour_arr = [
      [hour_sunday.open1, hour_monday.open1, hour_tuesday.open1, hour_wednesday.open1, hour_thursday.open1, hour_friday.open1, hour_saturday.open1],
      [hour_sunday.close1, hour_monday.close1, hour_tuesday.close1, hour_wednesday.close1, hour_thursday.close1, hour_friday.close1, hour_saturday.close1],
      [hour_sunday.open2, hour_monday.open2, hour_tuesday.open2, hour_wednesday.open2, hour_thursday.open2, hour_friday.open2, hour_saturday.open2],
      [hour_sunday.close2, hour_monday.close2, hour_tuesday.close2, hour_wednesday.close2, hour_thursday.close2, hour_friday.close2, hour_saturday.close2]
    ];

    setHour(hour_arr);

  }

  //Special Days update
  const handleSpecialDaysUpdate = (val) => {

    setUpdate(true);
    setEditValue(val);
    setSpecialDaysUpdateFlag(true);

    setSpecialDaysSelected(parseBusinessHoursDate(val.from_date));

    let location_arr = [];
    for (let i = 0; i < locationDetail.length; i++) {

      if (locationDetail[i].location_id === val.location_id) {

        location_arr.push(false)
      }
      else {
        location_arr.push(true)
      }
    }

    setLocationCheckedState(location_arr);

    //setting work hours

    let hour_sunday = val.sunday;
    let hour_monday = val.monday;
    let hour_tuesday = val.tuesday;
    let hour_wednesday = val.wednesday;
    let hour_thursday = val.thursday;
    let hour_friday = val.friday;
    let hour_saturday = val.saturday

    const hour_arr = [
      [hour_sunday.open1, hour_monday.open1, hour_tuesday.open1, hour_wednesday.open1, hour_thursday.open1, hour_friday.open1, hour_saturday.open1],
      [hour_sunday.close1, hour_monday.close1, hour_tuesday.close1, hour_wednesday.close1, hour_thursday.close1, hour_friday.close1, hour_saturday.close1],
      [hour_sunday.open2, hour_monday.open2, hour_tuesday.open2, hour_wednesday.open2, hour_thursday.open2, hour_friday.open2, hour_saturday.open2],
      [hour_sunday.close2, hour_monday.close2, hour_tuesday.close2, hour_wednesday.close2, hour_thursday.close2, hour_friday.close2, hour_saturday.close2]
    ];

    setHour(hour_arr);

  }


  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const hourFromat = (str) => {
    let new_str = "";
    let str_arr = str.split(", ");

    for (let i = 0; i < str_arr.length; i++)
      if (str_arr[i] === "00:00 - 00:00") {
      }
      else {
        if (new_str === "")
          new_str = str_arr[i]
        else
          new_str = new_str + ", " + str_arr[i]
      }

    if (new_str === "")
      new_str = "-"

    return new_str;
  }


  const handleLocationCheck2 = () => {

    let arr_json_mapping = []
    for (let i = 0; i < locationDetail.length; i++) {
      if (locationCheckedState[i] === false) {
        arr_json_mapping.push(true)
      }
    }
    if (arr_json_mapping.length < 1) {
      Swal.fire('Please select location(s)');
      setSpecialDaysModal(false);
      setSpecialDaysSelected("");
      return;
    }

  }

  return (
    <div className="business-hours-content">
      <div className="business-hours-form-heading" ref={titleRef}>
        <div>
          <span style={{ color: '#1E1E1E', fontSize: '21px' }}>
            {accessType === "View" ? "Select account to view business hours:" : (update ? "You are editing business hours for selected account:" : "Select account to add business hours:")}
          </span>
        </div>
      </div>


      <div className="business-hours-form-section">

        {/* <div className="col-1"></div> */}
        <div className="business-hours-form-container">

          <form className="business-hours-form">

            {/* First Row */}
            <div className="business-hours-account-row">
              <div className="business-hours-account-label">
                <label htmlFor="company_name" className="form-label">
                  Account Name
                </label>
              </div>

              <div className="business-hours-account-select">
                <Select
                  {...getEntitySelectProps()}
                  value={selectedCompanyOption}
                  inputId="company_name"
                  name="company_name"
                  options={companyNameOptions}
                  onChange={handleInputChangeCompanyName}
                  isLoading={accountsLoading}
                  isDisabled={accountsLoading || Boolean(accountsError) || companyNameOptions.length === 0}
                  placeholder="Select Account Name"
                  noOptionsMessage={() => "No accessible accounts"}
                />
              </div>
            </div>

            {accountsLoading && <Alert severity="info">Loading accessible accounts...</Alert>}
            {accountsError && <Alert severity="error">{accountsError}</Alert>}
            {!accountsLoading && !accountsError && companyNameOptions.length === 0 && (
              <Alert severity="warning">No accounts are available for your Business Hours access.</Alert>
            )}
            {selectedCompany && (
              <div className="business-hours-account-summary" aria-live="polite">
                <span><strong>Account ID:</strong> {String(selectedCompany._id)}</span>
                <span><strong>Account Type:</strong> {selectedCompany.account_type}</span>
              </div>
            )}

            {company_id && locationsLoading && <Alert severity="info">Loading account locations...</Alert>}
            {company_id && locationsError && <Alert severity="error">{locationsError}</Alert>}
            {company_id && !locationsLoading && !locationsError && locationDetail.length === 0 && (
              <Alert severity="warning">No location is assigned to your user for the selected account.</Alert>
            )}

            {/* Second Row */}
            {!(accessType === "View") && company_id && !locationsLoading && !locationsError && locationDetail.length > 0 ? (<>
              <div className="business-hours-editor-layout">
                <div className="business-hours-locations-panel">
                  <div className="business-hours-location-scroll">
                  <table className="table table-bordered table-condensed text-center branchTable2" >
                    <thead>
                      <tr>
                        <th scope="col" colSpan={2}>Select Location(s)</th>
                        {/* <th scope="col">Selected</th> */}

                      </tr>
                    </thead>
                    <tbody className="text-left ">
                      {locationDetail.length > 0 && locationDetail.map((val, i) => (
                        <tr key={val.location_id}>
                          <td>{val.location_name}</td>
                          <td><input type="checkbox" className='form-check-input' name={val.location_name}
                            checked={update && val.location_id === editValue.location_id ? true : !locationCheckedState[i]} onChange={() => handleLocationCheck(i)}
                            disabled={update ? true : false}
                          /></td>
                        </tr>
                      ))

                      }
                      {
                        locationDetail.length > 0 ? (
                          <tr style={{ borderColor: 'white' }}>
                            {/* <td>Select All</td><td><input type="checkbox" name="allowAll" /></td> */}
                            <td></td><td></td>
                          </tr>
                        ) : ""
                      }


                    </tbody>
                  </table>
                  </div>
                </div>

                <div className="business-hours-schedule-panel">

                  <div className="business-hours-table-scroll business-hours-schedule-scroll" tabIndex="0" aria-label="Business hours schedule">
                  <table className="table table-borderless">

                    <tbody>
                      <tr>
                        <th scope="row" style={{ verticalAlign: 'middle' }}>Type </th>
                        <td colSpan={3}>
                          <select className="form-select" onChange={(e) => setType(e.target.value)}
                            disabled={update ? true : false}
                          >
                            <option hidden selected={type === '' && "selected"}>Choose type</option>
                            <option value="both" selected={update && editValue.type === "both" ? "selected" : ""}>Both Summer & Winter</option>
                            <option value="summer" selected={update && editValue.type === "summer" ? "selected" : ""}>Summer</option>
                            <option value="winter" selected={update && editValue.type === "winter" ? "selected" : ""}>Winter</option>

                          </select>
                        </td>
                        <th colSpan={2} style={{ verticalAlign: 'middle' }}></th>
                        <td colSpan={3}></td>
                        <th colSpan={2} style={{ verticalAlign: 'middle' }}>Long weekend / Holidays </th>
                      </tr>
                      <tr>
                        <th scope="row" style={{ verticalAlign: 'middle' }}>From Date </th>
                        <td colSpan={3}>

                          <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy' onChange={(date, dateString) => {
                            setFromDate(date);
                          }}
                            disabledDate={(current) => {
                              if (toDate) {
                                return current && current.valueOf() > (toDate.valueOf() + (1 * 24 * 60 * 60)) || current.valueOf() < (new Date().valueOf() - (1000 * 24 * 60 * 60))
                              }
                              else {
                                return current && current.valueOf() < (new Date().valueOf() - (1000 * 24 * 60 * 60))
                              }
                            }}
                            style={{ width: '100%' }}
                            value={fromDate ? parseBusinessHoursDate(fromDate) : null}
                            disabled={specialDaysSelected ? true : false}
                          />
                        </td>
                        <th style={{ verticalAlign: 'middle' }}>To Date</th>
                        <td colSpan={3}>
                          <DatePicker size="large" format='MM-DD-YYYY' placeholder='mm-dd-yyyy' disabledDate={(current) => {
                            if (fromDate) {
                              return current && current.valueOf() < fromDate.valueOf();
                            }
                            else {
                              return current && current.valueOf() < new Date().valueOf() - (1000 * 24 * 60 * 60);
                            }
                          }} onChange={(date, dateString) => setToDate(date)} style={{ width: '100%' }}
                            value={toDate ? parseBusinessHoursDate(toDate) : null}
                            disabled={specialDaysSelected ? true : false}
                          />
                        </td>

                        <td colSpan={3}>

                          <DatePicker size="large" format='MM-DD-YYYY' placeholder='Eg: Christmas, Thanksgiving, etc.' style={{ width: '100%' }}
                            onSelect={(e) => { setSpecialDaysModal(true); setSpecialDaysSelected(e); handleLocationCheck2() }}
                            value={specialDaysSelected ? parseBusinessHoursDate(specialDaysSelected) : null}
                            disabled={update ? true : false}
                            disabledDate={(current) => {
                              return current && current.valueOf() < (new Date().valueOf() - (1000 * 24 * 60 * 60))
                            }}

                          />

                          <Modal
                            open={specialDaysModal}
                            onClose={() => setSpecialDaysModal(!specialDaysModal)}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box sx={style} className="business-hours-special-modal">

                              <Typography id="modal-modal-title" variant="h6" component="h2">
                                Long Weekend/Holidays open/close time
                              </Typography>
                              <Typography id="modal-modal-description" component="div" sx={{ mt: 2 }}>
                                <div className="business-hours-special-modal-table">
                                <table className="table table-borderless">
                                  <tbody>
                                    <tr>
                                      <th>Name <span style={{ fontSize: "10px" }}>{"("}Eg. Christmas, Thanksgiving etc.{")"}</span></th>
                                      <th>{<input type="text" className='form-control business-hours-special-name'
                                        value={specialDayName} onChange={(e) => setSpecialDayName(e.target.value)} />}</th>
                                    </tr>
                                    <tr>
                                      <th>Selected Date</th>
                                      <th>{dateFormat(new Date(specialDaysSelected).getMonth() + 1) + "-" + dateFormat(new Date(specialDaysSelected).getDate()) + "-" + new Date(specialDaysSelected).getFullYear()}</th>
                                    </tr>
                                    <tr>
                                      <th>Open</th>
                                      <td><select onChange={(e) => handleSpecialHour(e.target.value, 0)}>
                                        <option hidden>00:00</option>
                                        {hours.map((val) => (<option value={val.name} >{val.name}</option>))}</select></td>
                                    </tr>
                                    <tr>
                                      <th>Close</th>
                                      <td><select onChange={(e) => handleSpecialHour(e.target.value, 1)}>
                                        <option hidden>00:00</option>
                                        {hours.map((val) => (<option value={val.name} disabled={specialHour[0] >= val.name ? true : false}>{val.name}</option>))}</select></td>
                                    </tr>
                                    <tr>
                                      <th>Open</th>
                                      <td><select onChange={(e) => handleSpecialHour(e.target.value, 2)}>
                                        <option hidden>00:00</option>
                                        {hours.map((val) => (<option value={val.name} >{val.name}</option>))}</select></td>
                                    </tr>
                                    <tr>
                                      <th>Close</th>
                                      <td><select onChange={(e) => handleSpecialHour(e.target.value, 3)}>
                                        <option hidden>00:00</option>
                                        {hours.map((val) => (<option value={val.name} disabled={specialHour[2] >= val.name ? true : false}>{val.name}</option>))}</select></td>
                                    </tr>

                                    <tr>
                                      <th>
                                        <button className="btn btn-danger btn-sm" onClick={() => setSpecialDaysModal(!specialDaysModal)}>
                                          Close
                                        </button>
                                      </th>
                                      <td>
                                        <button type="submit" className="btn btn-success btn-sm" onClick={() => handleSpecialDays()}>
                                          Add This
                                        </button></td>
                                    </tr>
                                  </tbody>
                                </table>
                                </div>
                              </Typography>
                            </Box>
                          </Modal>

                        </td>
                      </tr>
                      <tr>
                        <th scope="row"></th>
                        <th>Sunday</th>
                        <th>Monday</th>
                        <th>Tuesday</th>
                        <th>Wednesday</th>
                        <th>Thursday</th>
                        <th>Friday</th>
                        <th>Saturday</th>
                      </tr>
                      <tr>
                        <th scope="row">Open</th>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 0, 0)}
                            disabled={specialDaysUpdateFlag && (editValue.sunday.open1 === "00:00" && editValue.sunday.close1 === "00:00"
                              && editValue.sunday.open2 === "00:00" && editValue.sunday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name}
                              selected={update && editValue.sunday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 0, 1)}
                            disabled={specialDaysUpdateFlag && (editValue.monday.open1 === "00:00" && editValue.monday.close1 === "00:00"
                              && editValue.monday.open2 === "00:00" && editValue.monday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.monday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 0, 2)}
                            disabled={specialDaysUpdateFlag && (editValue.tuesday.open1 === "00:00" && editValue.tuesday.close1 === "00:00"
                              && editValue.tuesday.open2 === "00:00" && editValue.tuesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.tuesday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 0, 3)}
                            disabled={specialDaysUpdateFlag && (editValue.wednesday.open1 === "00:00" && editValue.wednesday.close1 === "00:00"
                              && editValue.wednesday.open2 === "00:00" && editValue.wednesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.wednesday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>

                          <select onChange={(e) => handleHour(e.target.value, 0, 4)}
                            disabled={specialDaysUpdateFlag && (editValue.thursday.open1 === "00:00" && editValue.thursday.close1 === "00:00"
                              && editValue.thursday.open2 === "00:00" && editValue.thursday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.thursday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 0, 5)}
                            disabled={specialDaysUpdateFlag && (editValue.friday.open1 === "00:00" && editValue.friday.close1 === "00:00"
                              && editValue.friday.open2 === "00:00" && editValue.friday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.friday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 0, 6)}
                            disabled={specialDaysUpdateFlag && (editValue.saturday.open1 === "00:00" && editValue.saturday.close1 === "00:00"
                              && editValue.saturday.open2 === "00:00" && editValue.saturday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.saturday.open1 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>

                      </tr>
                      <tr>
                        <th scope="row">Close</th>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 0)}
                            disabled={specialDaysUpdateFlag && (editValue.sunday.open1 === "00:00" && editValue.sunday.close1 === "00:00"
                              && editValue.sunday.open2 === "00:00" && editValue.sunday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][0] > val.name ? true : false}
                              selected={update && editValue.sunday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 1)}
                            disabled={specialDaysUpdateFlag && (editValue.monday.open1 === "00:00" && editValue.monday.close1 === "00:00"
                              && editValue.monday.open2 === "00:00" && editValue.monday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][1] > val.name ? true : false}
                              selected={update && editValue.monday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 2)}
                            disabled={specialDaysUpdateFlag && (editValue.tuesday.open1 === "00:00" && editValue.tuesday.close1 === "00:00"
                              && editValue.tuesday.open2 === "00:00" && editValue.tuesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][2] > val.name ? true : false}
                              selected={update && editValue.tuesday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 3)}
                            disabled={specialDaysUpdateFlag && (editValue.wednesday.open1 === "00:00" && editValue.wednesday.close1 === "00:00"
                              && editValue.wednesday.open2 === "00:00" && editValue.wednesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][3] > val.name ? true : false}
                              selected={update && editValue.wednesday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 4)}
                            disabled={specialDaysUpdateFlag && (editValue.thursday.open1 === "00:00" && editValue.thursday.close1 === "00:00"
                              && editValue.thursday.open2 === "00:00" && editValue.thursday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][4] > val.name ? true : false}
                              selected={update && editValue.thursday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 5)}
                            disabled={specialDaysUpdateFlag && (editValue.friday.open1 === "00:00" && editValue.friday.close1 === "00:00"
                              && editValue.friday.open2 === "00:00" && editValue.friday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][5] > val.name ? true : false}
                              selected={update && editValue.friday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 1, 6)}
                            disabled={specialDaysUpdateFlag && (editValue.saturday.open1 === "00:00" && editValue.saturday.close1 === "00:00"
                              && editValue.saturday.open2 === "00:00" && editValue.saturday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[0][6] > val.name ? true : false}
                              selected={update && editValue.saturday.close1 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>

                      </tr>
                      <tr>
                        <th scope="row">Open</th>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 2, 0)}
                            disabled={specialDaysUpdateFlag && (editValue.sunday.open1 === "00:00" && editValue.sunday.close1 === "00:00"
                              && editValue.sunday.open2 === "00:00" && editValue.sunday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name}
                              selected={update && editValue.sunday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 2, 1)}
                            disabled={specialDaysUpdateFlag && (editValue.monday.open1 === "00:00" && editValue.monday.close1 === "00:00"
                              && editValue.monday.open2 === "00:00" && editValue.monday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.monday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 2, 2)}
                            disabled={specialDaysUpdateFlag && (editValue.tuesday.open1 === "00:00" && editValue.tuesday.close1 === "00:00"
                              && editValue.tuesday.open2 === "00:00" && editValue.tuesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.tuesday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 2, 3)}
                            disabled={specialDaysUpdateFlag && (editValue.wednesday.open1 === "00:00" && editValue.wednesday.close1 === "00:00"
                              && editValue.wednesday.open2 === "00:00" && editValue.wednesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.wednesday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>

                          <select onChange={(e) => handleHour(e.target.value, 2, 4)}
                            disabled={specialDaysUpdateFlag && (editValue.thursday.open1 === "00:00" && editValue.thursday.close1 === "00:00"
                              && editValue.thursday.open2 === "00:00" && editValue.thursday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.thursday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 2, 5)}
                            disabled={specialDaysUpdateFlag && (editValue.friday.open1 === "00:00" && editValue.friday.close1 === "00:00"
                              && editValue.friday.open2 === "00:00" && editValue.friday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.friday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 2, 6)}
                            disabled={specialDaysUpdateFlag && (editValue.saturday.open1 === "00:00" && editValue.saturday.close1 === "00:00"
                              && editValue.saturday.open2 === "00:00" && editValue.saturday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} selected={update && editValue.saturday.open2 === val.name ? "selected" : ""}>{val.name}</option>))}
                          </select>
                        </td>

                      </tr>
                      <tr>
                        <th scope="row">Close</th>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 0)}
                            disabled={specialDaysUpdateFlag && (editValue.sunday.open1 === "00:00" && editValue.sunday.close1 === "00:00"
                              && editValue.sunday.open2 === "00:00" && editValue.sunday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][0] > val.name ? true : false}
                              selected={update && editValue.sunday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 1)}
                            disabled={specialDaysUpdateFlag && (editValue.monday.open1 === "00:00" && editValue.monday.close1 === "00:00"
                              && editValue.monday.open2 === "00:00" && editValue.monday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][1] > val.name ? true : false}
                              selected={update && editValue.monday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 2)}
                            disabled={specialDaysUpdateFlag && (editValue.tuesday.open1 === "00:00" && editValue.tuesday.close1 === "00:00"
                              && editValue.tuesday.open2 === "00:00" && editValue.tuesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][2] > val.name ? true : false}
                              selected={update && editValue.tuesday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 3)}
                            disabled={specialDaysUpdateFlag && (editValue.wednesday.open1 === "00:00" && editValue.wednesday.close1 === "00:00"
                              && editValue.wednesday.open2 === "00:00" && editValue.wednesday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][3] > val.name ? true : false}
                              selected={update && editValue.wednesday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 4)}
                            disabled={specialDaysUpdateFlag && (editValue.thursday.open1 === "00:00" && editValue.thursday.close1 === "00:00"
                              && editValue.thursday.open2 === "00:00" && editValue.thursday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][4] > val.name ? true : false}
                              selected={update && editValue.thursday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 5)}
                            disabled={specialDaysUpdateFlag && (editValue.friday.open1 === "00:00" && editValue.friday.close1 === "00:00"
                              && editValue.friday.open2 === "00:00" && editValue.friday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][5] > val.name ? true : false}
                              selected={update && editValue.friday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>
                        <td>
                          <select onChange={(e) => handleHour(e.target.value, 3, 6)}
                            disabled={specialDaysUpdateFlag && (editValue.saturday.open1 === "00:00" && editValue.saturday.close1 === "00:00"
                              && editValue.saturday.open2 === "00:00" && editValue.saturday.close2 === "00:00") ? true : false}
                          >
                            <option selected={toDate === "" ? "selected" : ""} hidden>00:00</option>
                            {hours.map((val) => (<option value={val.name} disabled={hour[2][6] > val.name ? true : false}
                              selected={update && editValue.saturday.close2 === val.name ? "selected" : ""}
                            >{val.name}</option>))}
                          </select>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div className="business-hours-form-actions">

                    {
                      update ? (
                        <>
                          <div>
                            <button type="submit" className="btn btn-secondary" onClick={(e) => { cancelUpdate(e) }}>
                              Cancel
                            </button>
                          </div>
                          <div>
                            <button type="submit" className="btn btn-success" onClick={(e) => { specialDaysUpdateFlag ? updateSpecialDaysHandler(e) : updateHandler(e) }}>
                              Update
                            </button>
                          </div>

                        </>

                      ) :
                        (
                          <>
                            <div>
                              <button type="submit" className="btn btn-secondary" onClick={(e) => cancelUpdate(e)}>
                                Reset
                              </button>
                            </div>
                            <div>
                              <button type="submit" className="btn btn-success" onClick={(e) => submitHandler(e)}>
                                Submit
                              </button>
                            </div>
                          </>
                        )

                    }

                  </div>

                </div>
              </div>
            </>) : null}
          </form>
          {company_id && !locationsLoading && !locationsError ? (<>
            <section className="business-hours-existing-section">
                <h5 className=" mb-3">Existing Business Hours:</h5>

                {businessHoursLoading && <Alert severity="info">Loading existing business hours...</Alert>}
                {businessHoursError && <Alert severity="error">{businessHoursError}</Alert>}
                {!businessHoursLoading && !businessHoursError && businessHours.length === 0 && (
                  <Alert severity="info">No existing business hours were found for the accessible locations.</Alert>
                )}

                {!businessHoursLoading && !businessHoursError && businessHours.length > 0 && (
                <div className="business-hours-table-scroll business-hours-existing-scroll" tabIndex="0" aria-label="Existing business hours">
                <table className="table table-border">

                  <thead>
                    <tr>
                      <th scope="col">Location</th>
                      <th scope="col">Type</th>
                      <th scope="col">From Date</th>
                      <th scope="col">To Date  </th>
                      <th scope="col">Sunday</th>
                      <th scope="col">Monday</th>
                      <th scope="col">Tuesday</th>
                      <th scope="col">Wednesday</th>
                      <th scope="col">Thursday</th>
                      <th scope="col">Friday</th>
                      <th scope="col">Saturday</th>
                      <th scope="col">Added/Edited By</th>
                      <th scope="col">Added/Edited Date</th>
                      {
                        !(accessType === "View") &&
                        <>
                          <th scope="col">Edit</th>
                          <th scope="col">Delete</th>
                        </>
                      }

                    </tr>
                  </thead>

                  <tbody>

                    {
                      businessHours ? (
                        businessHours.filter((value1) => hashLocationNameVsID[value1.location_id] != undefined).map((val) => (
                          <tr key={val._id}>
                            <td scope="row">{hashLocationNameVsID[val.location_id]}</td>
                            <td>{val.type === "Special Day" ? val.special_day_name : val.type === "both" ? "Both Summer & Winter" : capitalizeFirstLetter(val.type)}</td>
                            <td>{formatDate(new Date(val.from_date))}</td>
                            <td>{formatDate(new Date(val.to_date))}</td>
                            <td>{hourFromat(val.sunday.open1 + " - " + val.sunday.close1) + ", " + hourFromat(val.sunday.open2 + " - " + val.sunday.close2)}</td>
                            <td>{hourFromat(val.monday.open1 + " - " + val.monday.close1) + ", " + hourFromat(val.monday.open2 + " - " + val.monday.close2)}</td>
                            <td>{hourFromat(val.tuesday.open1 + " - " + val.tuesday.close1) + ", " + hourFromat(val.tuesday.open2 + " - " + val.tuesday.close2)}</td>
                            <td>{hourFromat(val.wednesday.open1 + " - " + val.wednesday.close1) + ", " + hourFromat(val.wednesday.open2 + " - " + val.wednesday.close2)}</td>
                            <td>{hourFromat(val.thursday.open1 + " - " + val.thursday.close1) + ", " + hourFromat(val.thursday.open2 + " - " + val.thursday.close2)}</td>
                            <td>{hourFromat(val.friday.open1 + " - " + val.friday.close1) + ", " + hourFromat(val.friday.open2 + " - " + val.friday.close2)}</td>
                            <td>{hourFromat(val.saturday.open1 + " - " + val.saturday.close1) + ", " + hourFromat(val.saturday.open2 + " - " + val.saturday.close2)}</td>
                            {/* <td>{formatDate(new Date(val.special_day))}</td>
                          <td>{val.special_hour.open1 + " - " + val.special_hour.close1 + ", " + val.special_hour.open2 + " - " + val.special_hour.close2}</td> */}
                            <td>{val.updated_by}</td>
                            <td>{formatDate_withTime(new Date(val.updated_date))}</td>
                            {
                              !(accessType === "View") &&
                              <>
                                <td>{val.type === "Special Day" ? (<><span style={{ cursor: "pointer" }} onClick={() => { handleSpecialDaysUpdate(val); handleBackClick() }}><EditIcon /></span></>) : (<><span style={{ cursor: "pointer" }} onClick={() => { handleUpdate(val); handleBackClick() }}><EditIcon /></span></>)}</td>
                                <td><span style={{ cursor: "pointer" }} onClick={() => handleDelete(val._id, val.location_id)}><DeleteForeverIcon /></span></td>
                              </>}
                          </tr>
                        ))
                      ) : ""
                    }






                  </tbody>



                </table>
                </div>
                )}
            </section>
          </>) : ""
          }
        </div>

      </div>
    </div>
  );
}
